import { Component, OnInit } from '@angular/core';
import { NavList } from '../../shared/models/navlist.model'
import { NavService } from '../../shared/services/nav.service';
import { CommonService } from '../../shared/services/common.service';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
@Component({
  selector: 'app-kb-articles-folder-restore',
  templateUrl: './kb-articles-folder-restore.component.html',
  styleUrls: ['./kb-articles-folder-restore.component.scss']
})
export class KbArticlesFolderRestoreComponent implements OnInit {

  constructor(private commonService: CommonService, private router: Router, private navService: NavService, private authService: AuthService, private route: ActivatedRoute) {
    // this.navService.invokeEvent.subscribe(value => {
    //   if(value.type=='restore')
    //  this.item=value.item;
    this.newItem = JSON.parse(localStorage.getItem("folderItem"));
    this.item = this.newItem;


  }
  ngOnInit(): void {

    this.isArticlesMapped = this.item.children.filter(x => x.articleID != null).length > 0 ? true : false;

  }
  isArticlesMapped: boolean = true;
  newItem: any;
  item: NavList;
  filesChecked = [];
  selectedIds = [];
  selectedFiles = [];
  filesIdsNamesList = [];
  duplicateFoldersList = [];
  duplicatefolderErrorsMessage = "<ul>";
  isSelectAllChecked: boolean = false;
  noFilesChekedError: any = "";
  isNoFilesCheked: boolean = false;
  result: any;
  loading: any;
  fileNameErrorMessage: any;
  isInvalidRequest: any = false;
  duplicateChecks = [];
  onlyoneFileChecked: boolean = false;
  filteredItem: any;
  emptyParentItemArray: any = [];
  isLoading: boolean = false;
  UserId: any;
  //Folder restoring
  updateCheckedFileOptions(children, event, item) {
    if (event.target.checked) {
      this.filesChecked.push({ FolderId: children.id, Name: children.displayName, articleId: item.articleID == null ? 0 : item.articleID });

      if (this.filesChecked.length == item.children.filter(x => x.articleID != null).length) {
        this.isSelectAllChecked = true;
      }
      else {
        this.isSelectAllChecked = false;
      }
    }
    else {
      this.filesChecked = this.filesChecked.filter(x => x.FolderId != children.id);
      this.isSelectAllChecked = false;
    }

  }


  SelectAllFileOptions(item, event) {

    /*this.selectedIds = item.children.map(({ id }) => id, ({ displayName }) => displayName);*/
    if (this.filesChecked.length > 0) {
      this.filesChecked = [];
      this.filesIdsNamesList = [];
    }
    //item = item.filter(x=>x.articleID!=null);
    this.selectedIds = item.filter(x => x.articleID != null).map(({ id }) => id);
    //this.selectedIds = item.map(({ id }) => id);
    if (event.target.checked) {
      this.isSelectAllChecked = true;
      this.onlyoneFileChecked = true;
      for (let i = 0; i < this.selectedIds.length; i++) {
        // this.filesIdsNamesList[this.selectedIds[i]] = this.selectedFiles[i];
        this.filteredItem = item.filter(x => x.id == this.selectedIds[i]);
        this.filesChecked.push({ FolderId: this.filteredItem[0]["id"], Name: this.filteredItem[0]["displayName"], articleId: this.filteredItem[0]["articleID"] == null ? 0 : this.filteredItem[0]["articleID"] });


      }
    }
    else {
      this.isSelectAllChecked = false;
      this.onlyoneFileChecked = false;
      this.filesChecked = [];
      this.filesIdsNamesList = [];
    }

  }

  RestoreFolder(item) {
    this.duplicateChecks = [];
    this.isLoading = true;
    //console.log(document.querySelectorAll('.dds__form-check'));
    document.getElementById("fileError").innerHTML = "";
    if (item.children.length > 0 && item.children.filter(x => x.articleID != null).length > 0) {
      if (document.querySelectorAll('.dds__form-check').length <= 0) {
        this.isInvalidRequest = true;
        document.getElementById("fileError").innerHTML = "* No Files/Articles created to restore the folder.";
        return false;
      }

      if (this.filesChecked.length > 0) {
        for (let i = 0; i <= this.filesChecked.length - 1; i++) {
          if (item.children.filter(x => x.id == this.filesChecked[i]["FolderId"]).length > 0) {
            this.filteredItem = item.children.filter(x => x.id == this.filesChecked[i]["FolderId"]);

            //this.filesChecked.push({ FolderId: this.filteredItem[0]["id"], Name: this.filteredItem[0]["displayName"],articleId:this.filteredItem[0]["articleID"]==null?0:this.filteredItem[0]["articleID"]});
            this.duplicateChecks.push({ Name: this.filteredItem[0]["displayName"] });
          }
        }
        this.duplicateChecks = this.duplicateChecks.map(x => x["Name"]).filter((value, index, self) => self.indexOf(value) === index);
        if (this.duplicateChecks.length == this.filesChecked.length) {
          this.isNoFilesCheked = false;
          this.loading = true;
          this.commonService.checkFolderNameExists(item.id, item.displayName).subscribe(
            data => {
              this.result = data;
              if (this.result.Status == "Success") {
                /* alert("Hello")*/
                this.commonService.updateNavItemForRestoring(item.id, item.displayName);
                this.checkFileNamesForRestoringFolder(this.filesChecked, item);

              }
              else {
                this.loading = false;
                this.isLoading = false;
                this.isInvalidRequest = true;
                document.getElementById("fileError").innerHTML = "* Folder name already taken.";
                document.getElementById('scrolltopdiv').scrollIntoView();
                //this.openDialogRestore(item,"* Folder name already taken.")
              }
            });
        }
        else {
          this.isLoading = false;
          this.isNoFilesCheked = true;
          document.getElementById("fileError").innerHTML = "* All files names should be unique.";
          document.getElementById('scrolltopdiv').scrollIntoView();
          return false;
        }
      }
      else {
        this.isNoFilesCheked = true;
        this.isLoading = false;
        document.getElementById("fileError").innerHTML = "* Please Select atleast one file to restore.";
        document.getElementById('scrolltopdiv').scrollIntoView();
        return false;
      }
    }
    else {
      this.commonService.checkFolderNameExists(item.id, item.displayName).subscribe(
        data => {
          this.result = data;
          if (this.result.Status == "Success") {
            /* alert("Hello")*/
            this.emptyParentItemArray.push({ FolderId: item.id, Name: item.displayName, articleId: 1 });
            this.commonService.ActivateFolderForRestoring(item.id, item.displayName);
            this.commonService.setNotification("Folder Restored Succefully", "Success");
            this.commonService.getNavList();
            this.router.navigate(['/']);
            //this.checkFileNamesForRestoringFolder(this.filesChecked,item);

          }
          else {
            this.loading = false;
            this.isInvalidRequest = true;
            this.isLoading = false;
            this.fileNameErrorMessage = "* Folder name already taken.";
            document.getElementById('scrolltopdiv').scrollIntoView();
            //this.openDialogRestore(item,"* Folder name already taken.")
          }
        });
    }
  }
  checkFileNamesForRestoringFolder(inputData: Array<any>, item) {
    this.authService.itemValue.subscribe((nextValue) => {
      this.UserId = nextValue.UserId;

    })
    this.filesChecked = [];
    this.duplicatefolderErrorsMessage = "";
    for (let i = 0; i <= inputData.length - 1; i++) {

      if (item.children.filter(x => x.id == inputData[i]["FolderId"]).length > 0) {
        this.filteredItem = item.children.filter(x => x.id == inputData[i]["FolderId"]);
        this.filesChecked.push({ FolderId: this.filteredItem[0]["id"], Name: this.filteredItem[0]["displayName"], articleId: this.filteredItem[0]["articleID"] == null ? 0 : this.filteredItem[0]["articleID"] });
      }
    }
    inputData = this.filesChecked;
    this.commonService.checkRestoreFolderFilesNameExists(inputData)
      .subscribe((result) => {

        let data = result.data;
        if (result["Status"] == "Failure") {
          this.duplicateFoldersList = data.filter(x => x.IsAvailable != 1);
          if (this.duplicateFoldersList.length > 0) {
            for (let i = 0; i <= this.duplicateFoldersList.length - 1; i++) {
              this.duplicatefolderErrorsMessage += "<li>" + this.duplicateFoldersList[i]["Name"] + " file name already taken.</li>";
            }
            this.duplicatefolderErrorsMessage += "</ul>"
            document.getElementById("fileError").innerHTML = this.duplicatefolderErrorsMessage;
          }

          this.loading = false;
          this.isInvalidRequest = true;
          this.isLoading = false;
          document.getElementById('scrolltopdiv').scrollIntoView();
          return false;
        }
        else {
          for (let i = 0; i <= inputData.length - 1; i++) {

            this.commonService.updateNavItemForRestoring(inputData[i]["FolderId"], inputData[i]["Name"]);
          } let newArticleData = [];
          for (let i = 0; i <= inputData.length - 1; i++) {

            newArticleData.push({ FolderId: inputData[i]["FolderId"], ArticleId: inputData[i]["articleId"] == null ? 0 : inputData[i]["articleId"], userid: parseInt(this.UserId) });

          }
          this.commonService.updateArticleItemForRestoring(newArticleData);
          localStorage.removeItem("folderItem");

          this.loading = false;
          this.isLoading = false;
          document.getElementById('scrolltopdiv').scrollIntoView();
          return true;


        }

      },
        (error) => {
          this.loading = false;
          this.commonService.setNotification("Error! Please try after some time.", "Error");
          this.router.navigate(['/']);
        }
      );
  }


}
